import { customElement } from "lit/decorators.js";
import { LoadingButtonElement } from "../../core/components/loading-button.element";

@customElement("payment-button")
export class PaymentButtonElement extends LoadingButtonElement {

    protected override handleClick(event: PointerEvent) {
        this.dispatchEvent(new CustomEvent("payment-button-click"));
        event.stopPropagation();
    }
}